import { InboxOutlined } from '@ant-design/icons';
import { Col, Form, Row } from 'antd';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Link, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import CustomCard from '../../../components/Antd/Card';
import CustomButton from '../../../v2-components/Antd/Button';
import CustomDragDropUpload from '../../../v2-components/Antd/DragDropUpload';
import CustomFormItem from '../../../v2-components/Antd/FormItem';
import CustomImage from '../../../v2-components/Antd/Image';
import CustomInput from '../../../v2-components/Antd/Input';
import LoadingModal from '../../../v2-components/LoadingModal';
import { CustomNotification } from '../../../v2-components/Notification';
import { Service } from '../service';
import usePharmacyStore from '../templates/store/pharmacy-store';
import { getBase64 } from './handle/get-base64.handle';
import { imageSpecsByModule } from './handle/image-specs-by-module.handle';
import { capitalizeFirstLetter } from '../handle/capitalize-first-letter.handle';
import { validateLocation } from './handle/location-class-validation.handle';
import './style.scss';
import { nameAdapter } from '../locations/handle/name-adapter.handle';

export default function PharmacySlidersCreatePage() {
	const { template, location } = useParams();
	const history = useHistory();
	const [selectedPharmacy, locations, setLocations, isNewFile, platform, token] = usePharmacyStore((state) => [
		state.selectedPharmacy,
		state.locations,
		state.setLocations,
		state.isNewFile,
		state.platform,
		state.token,
	]);
	const [selectedLocation, setSelectedLocation] = useState({});
	const [selectedFile, setSelectedFile] = useState({});
	const [form] = Form.useForm();
	const [title, setTitle] = useState('');
	const [file, setFile] = useState(null);
	const [openLoadingModal, setOpenLoadingModal] = useState(false);
	const [isPreviewImg, setPreviewImg] = useState('');

	useEffect(() => {
		if (locations && locations.length > 0) {
			const currentLocation = locations.find((item) => item.location === location);
			setSelectedLocation(currentLocation);
		}

		if (!isNewFile.isNewFile) {
			form.setFieldsValue({
				title: !isNewFile?.isNewFile ? isNewFile.file.title : undefined,
				link: !isNewFile?.isNewFile && isNewFile.file.link ? isNewFile.file.link : null,
			});

			setSelectedFile(isNewFile.file);
			setPreviewImg(isNewFile.file.image);
			setTitle(isNewFile.file.title);
		}
	}, [form, isNewFile, isNewFile.id, isNewFile.isNewFile, location, locations]);

	const handleTitleChange = (e) => {
		setTitle(e.target.value);
	};

	const handlePreview = async (item) => {
		if (!item.url && !item.preview) {
			item.preview = await getBase64(item.originFileObj);
			setPreviewImg(item.preview);
		}
	};

	const handleUpload = (info) => {
		if (info.fileList.length > 0) {
			setFile(info.fileList[0]);
			handlePreview(info.fileList[0]);
		}
	};

	const handleOnFinish = async () => {
		setOpenLoadingModal(true);

		const values = form.getFieldsValue();
		const formData = new FormData();
		file && formData.append('file', file.originFileObj);
		formData.append('template', template);
		formData.append('location', location);
		formData.append('title', values.title);
		if (values.link) {
			formData.append('link', values.link);
		}

		if (file && isNewFile.isNewFile) {
			new Service()
				.createFile(token, formData)
				.then((response) => {
					setLocations(response.modules);
					setOpenLoadingModal(false);
					history.push(`/v2/pharmacy-sliders/templates/${template}/locations/${location}`);
					return CustomNotification({ type: 'success', description: 'Archivo creado exitosamente' });
				})
				.catch((error) => {
					setOpenLoadingModal(false);
					return CustomNotification({ type: 'error', description: 'Ha ocurrido un error al crear un nuevo archivo:', message: error });
				});
		} else {
			if (file) {
				formData.append('id', selectedFile._id);
				new Service()
					.updateFile(token, formData)
					.then((response) => {
						setLocations(response.modules);
						setOpenLoadingModal(false);
						history.push('/v2/pharmacy-sliders/templates/' + template + '/locations/' + location);
						return CustomNotification({ type: 'success', description: 'Archivo con imagen actualizado exitosamente' });
					})
					.catch((error) => {
						setOpenLoadingModal(false);
						return CustomNotification({
							type: 'error',
							description: 'Ha ocurrido un error al actualizar el archivo con image:',
							message: error,
						});
					});
			} else {
				const updatedData = {
					template: template,
					location: location,
					id: selectedFile._id,
					title: values.title,
					link: values.link ? values.link : ' ',
				};
				new Service()
					.updateFile(token, updatedData)
					.then((response) => {
						setLocations(response.modules);
						setOpenLoadingModal(false);
						history.push('/v2/pharmacy-sliders/templates/' + template + '/locations/' + location);
						return CustomNotification({ type: 'success', description: 'Archivo actualizado exitosamente' });
					})
					.catch((error) => {
						setOpenLoadingModal(false);
						return CustomNotification({ type: 'error', description: 'Ha ocurrido un error al actualizar el archivo:', message: error });
					});
			}
		}
	};

	const handleDeleteImg = () => {
		setPreviewImg(null);
		setFile(null);
	};

	return (
		<div className="pharmacy-sliders-create">
			<h1>{isNewFile?.isNewFile ? 'Crear imagen' : selectedFile?.title}</h1>
			<Link to={`/v2/pharmacy-sliders/templates/${template}/locations/${location}`}>
				Volver a {capitalizeFirstLetter(nameAdapter(selectedPharmacy, platform))} / {template} {selectedPharmacy === 'fanich' ? 'Anich' : selectedPharmacy} /{location}
			</Link>
			<Row className="create-file-cards-container" gutter={[16, 16]}>
				<Col md={12} xs={24}>
					<CustomCard title={'Datos del Módulo'}>
						<Form
							form={form}
							initialValues={{
								pharmacy: capitalizeFirstLetter(nameAdapter(selectedPharmacy, platform)),
								template: template,
								location: location,
								file: file,
							}}
							onFinish={handleOnFinish}
							className="create-form"
						>
							<div className="selects-container">
								<CustomFormItem name={'pharmacy'} label={'Plataforma'}>
									<CustomInput disabled={true} />
								</CustomFormItem>
								<CustomFormItem name={'template'} label={'Página'}>
									<CustomInput disabled={true} />
								</CustomFormItem>
							</div>

							<CustomFormItem name={'location'} label={'Módulo'}>
								<CustomInput disabled={true} />
							</CustomFormItem>
							<br></br>

							<CustomFormItem
								name={'title'}
								label={'Titulo imagen (no visible en la web)'}
								className="ant-form-vertical form-sub-titles"
								rules="required"
							>
								<CustomInput placeholder={'imagen 1'} value={title} onChange={handleTitleChange} />
							</CustomFormItem>

							<CustomFormItem name="file" label={'Cargar imagen'} className="ant-form-vertical form-sub-titles">
								<div>
									<p className="file-format">Formato: JPG/PNG - {imageSpecsByModule(location)}</p>
									<CustomDragDropUpload
										accept=".jpg, .png"
										maxCount={1}
										beforeUpload={() => false}
										multiple={false}
										onChange={(info) => handleUpload(info)}
										onRemove={() => setFile(null)}
										className="upload-image-container"
										showUploadList={false}
									>
										{!isPreviewImg ? (
											<div className="drag-drop-frame">
												<InboxOutlined className="drag-drop-icon" />
												<p className="ant-upload-text ">Haga clic o arrastre el archivo a esta área para cargarlo.</p>
											</div>
										) : (
											<div className="uploaded-img-container">
												<CustomImage alt="example" src={isPreviewImg} style={{ width: '100%' }} preview={false} />
											</div>
										)}
									</CustomDragDropUpload>

									<div className={'delete-span-container'}>
										<span className={`${!isPreviewImg && 'disabled-span'}`} onClick={handleDeleteImg}>
											Eliminar
										</span>
									</div>
								</div>
							</CustomFormItem>

							<p className="form-p">Al cliquear la imagen redireccionar a: (opcional)</p>
							<Link
								to={{ pathname: 'https://drive.google.com/file/d/14Oufu7u1dWAbXTZQnWOLkE6pvsr6rFUA/view?usp=sharing' }}
								target="_blank"
							>
								Instructivo para crear un link
							</Link>
							<CustomFormItem name={'link'} label={'Link'} className="ant-form-vertical">
								<CustomInput placeholder={'www.example.com'} />
							</CustomFormItem>

							<div className="save-button-container">
								<CustomButton type="default" htmlType="submit" disabled={!isPreviewImg || !title}>
									Guardar
								</CustomButton>
							</div>
						</Form>
					</CustomCard>
				</Col>
				<Col md={12} xs={24}>
					<CustomCard className={'create-img-container'}>
						<CustomImage className={validateLocation(location, 'width100')} src={selectedLocation?.img_cover} alt="img" />
					</CustomCard>
				</Col>
			</Row>
			<LoadingModal visible={openLoadingModal} />
		</div>
	);
}
